import type {
  Opportunity, OpportunityStatus, CriarOpportunityCommand,
  TransicionarOpportunityCommand, ConverterOpportunityCommand,
} from '@/domain/model/Opportunity';
import type { Venda } from '@/domain/model/Venda';
import type { Page } from '@/domain/model/Page';
import type { OpportunityGateway } from '@/application/port/out/OpportunityGateway';
import type {
  ListOpportunitiesUseCase, GetOpportunityUseCase,
  CriarOpportunityUseCase, TransicionarOpportunityUseCase, ConverterOpportunityUseCase,
} from '@/application/port/in/OpportunityUseCase';

export class ListOpportunities implements ListOpportunitiesUseCase {
  constructor(private readonly g: OpportunityGateway) {}
  execute(p: { status?: OpportunityStatus; leadId?: string; vendedorUserId?: string; page?: number; size?: number }): Promise<Page<Opportunity>> {
    return this.g.list(p);
  }
}
export class GetOpportunity implements GetOpportunityUseCase {
  constructor(private readonly g: OpportunityGateway) {}
  execute(id: string): Promise<Opportunity> { return this.g.get(id); }
}
export class CriarOpportunity implements CriarOpportunityUseCase {
  constructor(private readonly g: OpportunityGateway) {}
  execute(c: CriarOpportunityCommand): Promise<Opportunity> { return this.g.criar(c); }
}
export class TransicionarOpportunity implements TransicionarOpportunityUseCase {
  constructor(private readonly g: OpportunityGateway) {}
  execute(id: string, c: TransicionarOpportunityCommand): Promise<Opportunity> { return this.g.transicionar(id, c); }
}
export class ConverterOpportunity implements ConverterOpportunityUseCase {
  constructor(private readonly g: OpportunityGateway) {}
  execute(id: string, c: ConverterOpportunityCommand): Promise<Venda> { return this.g.converter(id, c); }
}
